import { render, staticRenderFns } from "./YourApplicationPage.vue?vue&type=template&id=5261f2e4&scoped=true&"
import script from "./YourApplicationPage.vue?vue&type=script&lang=js&"
export * from "./YourApplicationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5261f2e4",
  null
  
)

export default component.exports